var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.004,
    height: 18.004,
    viewBox: "0 0 18.004 18.004",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "logout_FILL0_wght400_GRAD0_opsz48",
    d: "M121.526-822a1.476,1.476,0,0,1-1.068-.45A1.428,1.428,0,0,1,120-823.5v-15a1.428,1.428,0,0,1,.458-1.05,1.476,1.476,0,0,1,1.068-.45h6.841a.742.742,0,0,1,.544.217.726.726,0,0,1,.219.538.712.712,0,0,1-.219.533.751.751,0,0,1-.544.213h-6.841v15h6.841a.743.743,0,0,1,.544.217.726.726,0,0,1,.219.538.712.712,0,0,1-.219.533.751.751,0,0,1-.544.212Zm13.859-8.252h-8.519a.742.742,0,0,1-.544-.217A.726.726,0,0,1,126.1-831a.711.711,0,0,1,.219-.533.75.75,0,0,1,.544-.213h8.468l-2.06-2.026a.671.671,0,0,1-.216-.525.762.762,0,0,1,.242-.525.752.752,0,0,1,.547-.225.752.752,0,0,1,.547.225l3.382,3.326a.714.714,0,0,1,.229.525.714.714,0,0,1-.229.525l-3.357,3.3a.682.682,0,0,1-.531.213.827.827,0,0,1-.547-.238.744.744,0,0,1-.219-.538.728.728,0,0,1,.229-.538Z",
    transform: "translate(-120 840)",
    fill: "#ff5d48"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.7d5c9772a220430ceebf5be2fc53d7f0.svg";
export { ForwardRef as ReactComponent };